import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPeople"><Path d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z" fill="currentColor"/><Path d="M12.0002 12C8.021 12 5.04789 14.6204 3.93808 18.2128C3.46872 19.7321 4.75753 21 6.18333 21H17.817C19.2428 21 20.5316 19.7321 20.0622 18.2128C18.9524 14.6204 15.9793 12 12.0002 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeople;
